import React from 'react';
import ReactDOM from 'react-dom';
import { Box, Typography } from '@mui/material';

export function HeritageDestinationSearchResultsList({ searchResults, searchQuery, onResultClick }) {
  return (
    <Box
      sx={{
        maxHeight: '340px',
        overflowY: 'auto',
        py: '6px',
        WebkitOverflowScrolling: 'touch',
        '&::-webkit-scrollbar': { width: 5 },
        '&::-webkit-scrollbar-thumb': { bgcolor: '#E0E0E0', borderRadius: 3 },
      }}
    >
      {searchResults.length > 0 ? (
        searchResults.map((r, i) => (
          <Box
            key={`${r.name}-${i}`}
            onClick={() => onResultClick(r)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              px: '14px',
              py: '10px',
              cursor: 'pointer',
              transition: 'background 0.12s ease',
              '&:hover': { bgcolor: 'var(--yovo-grey-100)' },
            }}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: '10px',
                bgcolor: '#EDEDF0',
                flexShrink: 0,
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Box
                component="img"
                src={
                  r.image ||
                  `https://ui-avatars.com/api/?name=${encodeURIComponent(r.name)}&background=EDEDF0&color=545665&size=76&font-size=0.33&bold=true`
                }
                alt={r.name}
                onError={(e) => {
                  e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    r.name,
                  )}&background=EDEDF0&color=545665&size=76&font-size=0.33&bold=true`;
                }}
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            </Box>
            <Box sx={{ overflow: 'hidden', flex: 1, minWidth: 0 }}>
              <Typography
                sx={{
                  fontFamily: 'var(--yovo-font-primary)',
                  fontWeight: 500,
                  fontSize: 'var(--yovo-text-base)',
                  lineHeight: 'var(--yovo-leading-base)',
                  color: 'var(--yovo-base-black)',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {r.name}
              </Typography>
              <Typography
                sx={{
                  fontFamily: 'var(--yovo-font-primary)',
                  fontSize: '11px',
                  color: 'var(--yovo-grey-600)',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  lineHeight: '16px',
                }}
              >
                {r.location}
                {r.region && r.location !== r.region ? `, ${r.region}` : ''}
                {r.source !== 'international' ? ', India' : ''}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Typography
          sx={{
            fontFamily: 'var(--yovo-font-primary)',
            fontSize: '13px',
            color: 'var(--yovo-grey-700)',
            textAlign: 'center',
            py: '18px',
          }}
        >
          No places found for &quot;{searchQuery}&quot;
        </Typography>
      )}
    </Box>
  );
}

/** Fixed dropdown under the anchor — same shell as legacy YovoTripHeader portal. */
export default function HeritageDestinationSearchDropdown({
  open,
  position,
  dropdownRef,
  searchResults,
  searchQuery,
  onResultClick,
}) {
  if (!open || typeof document === 'undefined') return null;

  const { top, left, width } = position;

  return ReactDOM.createPortal(
    <Box
      ref={dropdownRef}
      className="yovo-header-search-dropdown"
      sx={{
        position: 'fixed',
        top: `${top + 12}px`,
        left: `${left}px`,
        width: `${Math.max(0, width)}px`,
        maxWidth: 'calc(100vw - 16px)',
        boxSizing: 'border-box',
        bgcolor: '#fff',
        borderRadius: '20px',
        border: '1.5px solid var(--yovo-grey-300)',
        boxShadow: 'var(--yovo-shadow-xl)',
        overflow: 'hidden',
        zIndex: 99999,
      }}
    >
      <HeritageDestinationSearchResultsList
        searchResults={searchResults}
        searchQuery={searchQuery}
        onResultClick={onResultClick}
      />
    </Box>,
    document.body,
  );
}
